/**
 * Desktop-Chromium kann PDF-Blob-URLs in iframes anzeigen.
 * Viele Mobilbrowser (Android Chrome/WebView, iOS Safari/WKWebView) zeigen
 * dabei nur eine weiße Fläche – dort rendern wir per PDF.js.
 */
export function canEmbedPdfInline(): boolean {
  if (typeof navigator === "undefined") return true;
  const ua = navigator.userAgent || "";

  // Android (Chrome, Samsung Internet, WebViews, …)
  if (/Android/i.test(ua)) return false;

  // iPhone / iPod / klassisches iPad
  if (/iPad|iPhone|iPod/i.test(ua)) return false;

  // iPadOS 13+ meldet sich als Macintosh mit Touch.
  if (
    navigator.platform === "MacIntel" &&
    typeof navigator.maxTouchPoints === "number" &&
    navigator.maxTouchPoints > 1
  ) {
    return false;
  }

  return true;
}
